export default __webpack_public_path__ + "static/media/constomer_rep_wb.58d3b5c8.jpg";